module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00024-fs8.c88e377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00024-fs8.png
// module id = 177
// module chunks = 0